import { Navigate } from "react-router-dom";
import { useAuth } from "@itaas/core/auth/useAuth";
import { getLicensedModulesFromSession } from "@/auth/suite-auth.service";
import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { canAccessPlatformSettings } from "@/navigation/platform-access";
import { routes } from "@/router/all_routes";
import { openTenantAdminPage } from "@itaas/core/admin/tenant-admin-navigation";
import { getModuleBaseUrl } from "@/config";

export function PlatformSettingsPage() {
  const { user, tenant } = useAuth();

  if (!canAccessPlatformSettings(user)) {
    return <Navigate to={routes.accessDenied} replace />;
  }

  const session = loadStoredSession();
  const licensed = session ? getLicensedModulesFromSession(session) : [];

  return (
    <div className="suite-platform-page">
      <header className="suite-platform-page__header">
        <div>
          <h1 className="h4 mb-1">Paramètres plateforme</h1>
          <p className="text-muted small mb-0">
            Organisation courante et modules activés pour ce tenant.
          </p>
        </div>
      </header>

      <div className="card mb-3">
        <div className="card-body">
          <h2 className="h6">Organisation</h2>
          <ul className="list-unstyled small mb-0">
            <li>Nom : {tenant?.name ?? "—"}</li>
            <li>Slug : {tenant?.slug ?? "—"}</li>
            <li>Utilisateur : {user?.email ?? "—"}</li>
          </ul>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <h2 className="h6">Modules licenciés</h2>
          {licensed.length === 0 ? (
            <p className="small text-muted mb-0">Aucun module licencié détecté.</p>
          ) : (
            <ul className="small mb-0">
              {licensed.map((moduleId) => (
                <li key={moduleId}>
                  <code>{moduleId}</code>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <button
        type="button"
        className="btn btn-sm btn-outline-primary"
        onClick={() =>
          openTenantAdminPage(getModuleBaseUrl("rh"), "/tenant/admin/provisioning")
        }
      >
        Ouvrir le provisionnement (RH)
      </button>
    </div>
  );
}
